import { mergeSx } from "@/utils";

import { useFetchLogoContent } from "@/hooks/useFetchLogoContent";
import type { NestedLogoComponentProps } from "@/types";
import { SvgIcon } from "../SvgIcon";

export function DocsHorizontalLockup({
  sx,
  testId,
  ...props
}: NestedLogoComponentProps) {
  const svgContent = useFetchLogoContent("DocsHorizontalLockup");
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 275 48"
      testId={testId}
      sx={mergeSx({ fill: "base.color.brand.1", w: "200px" }, sx)}
    >
      {svgContent && (
        <g
          data-testid={`${testId}__g`}
          dangerouslySetInnerHTML={{ __html: svgContent?.join?.("") }}
        />
      )}
    </SvgIcon>
  );
}

DocsHorizontalLockup.displayName = "DocsHorizontalLockup";
